module.exports = __webpack_public_path__ + "static/logo-light-19581ce454bb08c7ade8dc5ce529788a.png";